export default "__VITE_ASSET__a8cd3d7e__"